import TcmSelectAc from './src/main';

/* istanbul ignore next */
TcmSelectAc.install = function(Vue) {
  Vue.component(TcmSelectAc.name, TcmSelectAc);
};

export default TcmSelectAc;
